import React from "react";
import CommonLayout from "./Layout/CommonLayout";
import { useEffect } from "react";
import { userId_local_storage_key } from "./helpers/common";
import { useDispatch } from "react-redux";
import { getCustomerDetails, logout, updateProfile } from "./actions/customer";
import { CustomSnackbar } from "./helpers/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./index.css";
import SignupPopup from "./helpers/Common/SignupPopup";
import { loginSuccess } from "./actions/customer";
import { scheduleSessionExpiry, isStoredSessionExpired } from "./helpers/SessionTimer";

function App() {

  const userId = localStorage.getItem(userId_local_storage_key);

  console.log("Found Candidate ID:", userId); // Ab ye 78 dikhayega

  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.customer);
  const navigate = useNavigate(



  );

  // const { pathname } = useLocation();

  // const customerType = localStorage.getItem("customer_type");

  console.log("Current Customer ID:", userId); // <--- Ye check karein



  // useEffect(() => {

  //   if (userId) {

  //     console.log("useEffect Triggered!"); // <--- Ye message aa raha hai?

  //     dispatch(getCustomerDetails(userId



  //     )).then((res) => {

  //       console.log("Response:", res);

  //     });

  //   }

  // }, [userId, dispatch, navigate]);



  useEffect(() => {

    if (!userId) return;

    // 🎯 FIX: don't re-authenticate / restore a session that's already
    // expired — this was undoing the auto-logout, causing an infinite
    // logout → restore → reload loop.
    if (isStoredSessionExpired()) return;



    console.log("Fetching profile for:", userId);



    dispatch(getCustomerDetails(userId))

      .then((res) => {

        const customer = res?.data?.data;



        if (!customer) return;

        // 🎯 FIX: double-check expiry again right before restoring, in
        // case it expired while this request was in flight.
        if (isStoredSessionExpired()) return;



        dispatch(

          loginSuccess({

            customer: {

              id: customer.userId,

              name: customer.fullName || customer.email,

              email: customer.email,

              mobile_number: customer.phoneNumber,

              customerType: 0,

              additional_fields: JSON.stringify({

                profile_picture: customer.profileImage,

              }),

            },



            // ✅ FIX: correct token

            token: localStorage.getItem("webvi_authToken"), // 👈 IMPORTANT

          })

        );

      })

      .catch((err) => {

        console.error("Profile fetch error:", err);

      });

  }, [userId, dispatch]);



  // 🎯 Schedule automatic logout at the token's real expiry time — runs
  // once when the app first loads/refreshes, reading whatever expiresAt is
  // already stored (works whether the user just logged in or is resuming
  // an earlier session).
  useEffect(() => {

    scheduleSessionExpiry();

  }, []);



  // useEffect(() => {

  //   if (

  //     (pathname.includes("employer") && customerType === "2") ||

  //     (pathname.includes("candidate") && customerType === "1")

  //   ) {

  //     CustomSnackbar.error(`You don't allowed to perform this action!`);

  //     navigate(-1);

  //   }

  // }, [customerType, navigate, pathname]);



  return (

    <>

      <SignupPopup />



      <CommonLayout />

    </>

  );

}

export default App;